<template>
  <div class="flex justify-center items-center h-full no-content">
    <span class="text-xs msg">{{ translatedMessage }}</span>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, default: "" },
  },
  computed: {
    translatedMessage() {
      return this.message || this.$t("common.base.label.no_data_available");
    },
  },
};
</script>

<style lang="scss" scoped>
.no-content {
  .msg {
    color: #000 !important;
  }
}
</style>
